export interface RouteTransitionState {
	previousUrl: string | null;
	currentUrl: string;
	pathPattern: string;
}

/**
 * Analyses route transition to determine if journey exit callback should be triggered
 */
export const confirmCallbackTrigger = (state: RouteTransitionState): boolean => {
	const { previousUrl, currentUrl, pathPattern } = state;

	const wasPreviouslyOnJourney = previousUrl?.includes(pathPattern) ?? false;
	const isCurrentlyOnJourney = currentUrl.includes(pathPattern);
	return wasPreviouslyOnJourney && !isCurrentlyOnJourney;
};
